// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_e3f8c","dangerous":"view-default_dangerous_1KpKn","tableColumnText":"view-default_tableColumnText_1nLYD"};